import React from 'react';
import './style.scss';
import cn from 'classnames';
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io';
import { useTranslation } from 'react-i18next';

export const Pagination = ({ numPages, currentPage, setCurrentPage, isLoading, className, pageDelta = 2 }) => {
    const { t } = useTranslation();
    const paginator_addition = '';
    const handlePaginateTo = (event) => {
        event.preventDefault();
        setCurrentPage(Number(event.currentTarget.dataset.page));
    };

    // const page = currentPage || 1;
    const pageRange = [];

    for (let i = currentPage - pageDelta; i <= currentPage + pageDelta; i++) {
        if (i >= 1 && i <= numPages) {
            pageRange.push(i);
        }
    }

    return (
        <nav className={cn('pagination', className)}>
            {currentPage !== 1 ? (
                <a className={cn('pagination__previous', { disabled: isLoading })} href={`?page=${currentPage - 1}${paginator_addition}`} data-page={currentPage - 1} key="pagination__previous" onClick={handlePaginateTo}>
                    <div className="cursor-pointer flex items-center px-3 py-2 border border-gray-300 rounded-lg">
                        <IoMdArrowBack />
                        <span className="ml-1 text-gray-700">{t('Previous')}</span>
                    </div>
                </a>
            ) : (
                <div className="flex items-center pagination__previous active px-3 py-2 border border-gray-300 rounded-lg">
                    <IoMdArrowBack />
                    <span className="ml-1 text-gray-700">{t('Previous')}</span>
                </div>
            )}

            <span className="pagination__pages">
                {currentPage > 1 + pageDelta && (
                    <>
                        <a
                            className={cn('pagination__page', {
                                active: currentPage === 1,
                                'cursor-default': isLoading || currentPage === 1,
                            })}
                            href={`?page=1${paginator_addition}`}
                            data-page={1}
                            onClick={handlePaginateTo}
                        >
                            1
                        </a>
                        {currentPage > 1 + pageDelta + 1 && <span className="pagination__spacer">...</span>}
                    </>
                )}

                {pageRange.map((pageNum) => (
                    <a
                        className={cn('pagination__page', {
                            active: currentPage === pageNum,
                            'cursor-default': isLoading || currentPage === pageNum,
                        })}
                        href={`?page=${pageNum}${paginator_addition}`}
                        data-page={pageNum}
                        key={pageNum}
                        onClick={handlePaginateTo}
                    >
                        {pageNum}
                    </a>
                ))}

                {currentPage < numPages - pageDelta && (
                    <>
                        {currentPage < numPages - pageDelta - 1 && <span className="pagination__spacer">...</span>}
                        <a
                            className={cn('pagination__page', {
                                active: currentPage === numPages,
                                'cursor-default': isLoading || currentPage === numPages,
                            })}
                            href={`?page=${numPages}${paginator_addition}`}
                            data-page={numPages}
                            onClick={handlePaginateTo}
                        >
                            {numPages}
                        </a>
                    </>
                )}
            </span>

            {currentPage !== numPages ? (
                <a className={cn('pagination__next', { disabled: isLoading })} href={`?page=${currentPage + 1}${paginator_addition}`} data-page={currentPage + 1} key="pagination__next" onClick={handlePaginateTo}>
                    <div className="flex items-center active px-3 py-2 border border-gray-300 rounded-lg">
                        <span className="mr-1 text-gray-700">{t('Next')}</span>
                        <IoMdArrowForward />
                    </div>
                </a>
            ) : (
                <div className="flex items-center pagination__next active px-3 py-2 border border-gray-300 rounded-lg">
                    <span className="mr-1 text-gray-700">{t('Next')}</span>
                    <IoMdArrowForward />
                </div>
            )}
        </nav>
    );
};
